var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseBIPage',{attrs:{"title":'C端订单统计',"baseSrc":'https://bi.aliyuncs.com/dashboard/view/pc.htm?pageId=34bc4a81-9cb5-42e0-87eb-54a02d0909d6&qbi_version_param=2'}})
}
var staticRenderFns = []

export { render, staticRenderFns }